var map = {
	"./gogo.dark.blue.scss": [
		79,
		23
	],
	"./gogo.dark.green.scss": [
		80,
		24
	],
	"./gogo.dark.orange.scss": [
		81,
		25
	],
	"./gogo.dark.purple.scss": [
		82,
		26
	],
	"./gogo.dark.red.scss": [
		83,
		27
	],
	"./gogo.light.blue.scss": [
		84,
		28
	],
	"./gogo.light.green.scss": [
		85,
		29
	],
	"./gogo.light.orange.scss": [
		86,
		30
	],
	"./gogo.light.purple.scss": [
		87,
		31
	],
	"./gogo.light.red.scss": [
		88,
		32
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 63;
module.exports = webpackAsyncContext;